import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon, ImageIcon } from "lucide-react";
import type { Project } from "../../data/work";
import { PlaceholderTag } from "../ui/PlaceholderTag";
export function WorkCard({
  project
}: {
  project: Project;
}) {
  return <Link to={`/work/${project.slug}`} className="group flex h-full flex-col overflow-hidden rounded-[clamp(1rem,1.2vw,1.5rem)] border border-line bg-ink-2 transition-[transform,border-color] duration-200 ease-out hover:-translate-y-1 hover:border-line-strong" data-id="element-492" data-mp="gn4tij4tm0p6">
      <div className="placeholder-hatch relative grid aspect-[16/10] place-items-center border-b border-line bg-ink-3" data-id="element-493" data-mp="3k1ilux1ogpjm">
        <div className="flex flex-col items-center gap-2 text-muted" data-id="element-494" data-mp="3ttelicjewnpy">
          <ImageIcon className="h-6 w-6" aria-hidden data-id="element-495" data-mp="3tvrdzjmsqgh9" />
          <span className="text-sm" data-id="element-496" data-mp="2wd9549jbmrzc">Project screenshot coming soon</span>
        </div>
        <div className="absolute left-4 top-4" data-id="element-497" data-mp="31cu1qdb0qo8w"><PlaceholderTag data-id="element-498" data-mp="31bstegle0fuv">Placeholder project</PlaceholderTag></div>
      </div>
      <div className="flex flex-1 flex-col p-[clamp(1.25rem,1.6vw,2rem)]" data-id="element-499" data-mp="334f2cbbhyaz9">
        <p className="t-eyebrow text-accent-soft" data-id="element-500" data-mp="2y5vdo35iql37">{project.category}</p>
        <h3 className="t-h3 mt-3" data-id="element-501" data-mp="2y8pz9y09qby7">{project.title}</h3>
        <p className="mt-2 text-muted" data-id="element-502" data-mp="2telsber063x4">{project.summary}</p>
        <span className="mt-auto inline-flex items-center gap-2 pt-6 text-[15px] text-fg-2 group-hover:text-fg" data-id="element-503" data-mp="2pebkrxnkb5g5">
          View case study <ArrowUpRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-504" data-mp="2kg0ajltcusxe" />
        </span>
      </div>
    </Link>;
}